import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

class MultiSelect extends Component {
  constructor(props) {
    super(props);

    const values = props.value.split(', ')
      .filter(i => !!i && i !== '');

    this.state = {
      selectedValues: values && values.length > 0
        ? values.map(value => Number(value) > 0 ? Number(value) : value)
        : [],
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, value } = this.props;

    if (prevProps.id !== id) {
      const values = value.split(', ').filter(i => !!i && i !== '');
      this.setState({
        selectedValues: values && values.length > 0
          ? values.map(value => Number(value) > 0 ? Number(value) : value)
          : [],
      });
    }
  }

  selectOption = (statementValue) => {
    const { selectedValues } = this.state;
    const { id, onChange, feedback, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    const index = selectedValues.findIndex(i => i === statementValue);
    let values = [];
    if (selectedValues.length >= 3 && !selectedValues.includes(statementValue)) {
      return;
    } else {
      if (index >= 0) {
        values = selectedValues.filter(i => i !== statementValue);
      } else {
        if (statementValue !== 'Not Applicable' && selectedValues.includes('Not Applicable')) {
          return;
        }

        if (statementValue === 'Not Applicable' && selectedValues.length > 0) {
          return;
        }

        values = [
          ...selectedValues,
          statementValue,
        ];
      }
    }

    if (!values.includes('Not Applicable')) {
      values.sort((a, b) => a - b);
    }

    if (onChange) {
      onChange({
        id,
        value: values.join(', '),
        type: 'text',
        hasError: false,
        feedback,
      });
    }

    this.setState({
      selectedValues: values,
    });
  }

  render() {
    const { title, statements, readonlyMode } = this.props;
    const { selectedValues } = this.state;

    return (
      <div className="MultiSelectWrapper">
        {title && (
          <h5
            className="title"
            dangerouslySetInnerHTML={
              { __html: title }
            } />
        )}

        <div className="MultiSelectOptions">
          {statements.map(({ id, text }, index) => (
            <button
              key={`multi-select-option-${index}`}
              className={cn("MultiSelectOption", {
                MultiSelectOption_selected: text === 'Not Applicable' ? selectedValues.includes(text) : selectedValues.includes(id),
                MultiSelectOption_nofocus: readonlyMode,
              })}
              onClick={() => text === 'Not Applicable' ? this.selectOption(text) : this.selectOption(id)}
            >
              {text}
            </button>
          ))}
        </div>
      </div>
    );
  }
}

MultiSelect.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  feedback: PropTypes.number,
  statements: PropTypes.arrayOf(PropTypes.object),
};

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/multi-select/index.js